module.exports = __webpack_public_path__ + "static/media/dj.d0d98eea.svg";